import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../../../hooks/useAuthorizedRequestForFileUpload';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../../components/ModalsCommonFunctions';
import Pagination from '../../../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../../components/Navigation';
import ReactPlayer from 'react-player';
import convertVideoUrl from '../../../components/convertVideoUrl';

const LiteracyVideos = () => {
    const authorizedAxios = generateAxiosInstance()
    const [formData, setFormData] = useState([])

    const [played, setPlayed] = useState(0);
    const playerRef = useRef(null);
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [isFullScreen, setFullScreen] = useState(false);
    const [play, setPlay] = useState(false);

    const initialFormState = {
        category: "L",
        contentType: "V",
        filePath: '',
        fileName: '',
        title: '',
        description: '',
        flnTagMasterId: '',
        gradeMasterIds: [],
        streamOrMediumMasterId: '',
        boardMasterId: ''
    }

    const [literacyVideosData, setLiteracyVideosData] = useState(initialFormState)
    const [literacyVideoList, setLiteracyVideoList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState("")
    const [flnTag, setFlnTag] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [boardSort, setBoardSort] = useState(null);
    const [mediumSort, setMediumSort] = useState(null);
    const [pdfTitleSort, setPdfTitleSort] = useState(null);
    const [pdfDescriptionSort, setPdfDescriptionSort] = useState(null);
    const [tagNameSort, setTagNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["boardMasterDetails.boardName", "streamOrMediumMasterDetails.streamName", "referenceBookMasterDetails.gradeMasterDetails.gradeName", "fileName", "title", "description", "tagMasterDetails.tagName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (literacyVideosData.boardMasterId.length !== 0) {
                setCurrPage(1);
                setLiteracyVideoList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        getLiteracyVideos();
    }, [literacyVideosData]);

    const getApiUrl = () => {
        let apiUrl = `/fln-master?category=${literacyVideosData.category}&contentType=${literacyVideosData.contentType}&`;

        if (literacyVideosData.boardMasterId !== '') {
            apiUrl += `boardMasterId=${literacyVideosData.boardMasterId}&`;
        }
        if (literacyVideosData.streamOrMediumMasterId !== '') {
            apiUrl += `streamOrMediumMasterId=${literacyVideosData.streamOrMediumMasterId}&`;
        }
        if (literacyVideosData.streamOrMediumMasterId !== '') {
            apiUrl += `streamOrMediumMasterId=${literacyVideosData.streamOrMediumMasterId}&`;
        }
        if (literacyVideosData.gradeMasterIds.length != 0) {
            apiUrl += `gradeMasterIds=${literacyVideosData.gradeMasterIds}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(literacyVideoList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(literacyVideoList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > literacyVideoList.length) {
            endIndex = literacyVideoList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(literacyVideoList.slice(startIndex, endIndex));
    }, [literacyVideoList, currPage, itemsPerPage]);

    const getLiteracyVideoList = async () => {
        if (literacyVideosData.boardMasterId !== '') {
            try {
                let apiUrl = getApiUrl();
                const response = await authorizedAxios.get(apiUrl);
                setLiteracyVideoList(response.data.result);
                setAddNew(!addNew);
            } catch (error) {
                setLiteracyVideoList(error?.response?.data.result);
                console.error('Error fetching data:', error);
            }
        }
    }

    const getLiteracyVideos = async () => {
        if (literacyVideosData.boardMasterId !== '') {
            try {
                let apiUrl = getApiUrl();
                const response = await authorizedAxios.get(apiUrl);
                setLiteracyVideoList(response.data.result);
            } catch (error) {
                setLiteracyVideoList([]);
                console.error('Error fetching data:', error);
            }
        }
    }

    useEffect(() => {
        getSyllabusStructure();
        getFlnTagMaster();
    }, []);

    const getSyllabusStructure = () => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getFlnTagMaster = () => {
        const apiUrl = `/fln-tag`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFlnTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setLiteracyVideosData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(literacyVideosData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(literacyVideosData)) {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [literacyVideosData])

    const addLiteracyVideos = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/fln-master`;
                const response = await authorizedAxios.post(apiUrl, {...literacyVideosData, filePath: convertVideoUrl(literacyVideosData.filePath)});
                await getLiteracyVideoList();
                setRefresh(!refresh);
                setLiteracyVideosData((prevData) => {
                    return {
                        ...prevData,
                        filePath: '',
                        fileName: '',
                        title: '',
                        description: ''
                    }
                });

                // setLiteracyVideoList(response.data.result);
                setSaveId(response.data.result.id);
                setBoardSort(null);
                setMediumSort(null);
                setPdfTitleSort(null);
                setPdfDescriptionSort(null);
                setTagNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(literacyVideosData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteVideo = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/fln-master?id=${id}`;
                const response = await authorizedAxios.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, literacyVideoList.length);
                await getLiteracyVideos();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const ClassList = formData?.gradeData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.gradeName
        }
    }) || [];

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setLiteracyVideosData((prevData) => {
            return {
                ...prevData,
                gradeMasterIds: selectedIds,
            }
        })
    }

    useEffect(() => {
        if (boardSort == true || boardSort == false) {
            setMediumSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [boardSort])

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setBoardSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (pdfTitleSort == true || pdfTitleSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [pdfTitleSort])

    useEffect(() => {
        if (pdfDescriptionSort == true || pdfDescriptionSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfTitleSort(null);
            setTagNameSort(null);
        }
    }, [pdfDescriptionSort])

    useEffect(() => {
        if (tagNameSort == true || tagNameSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [tagNameSort])

    console.log({ literacyVideosData })

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Videos</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-upload"></i>Videos</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='boardMasterId' onChange={handleInputChange} value={literacyVideosData.boardMasterId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            formData?.boardData?.map((board) => {
                                                                return <option key={board.id} value={board.id}>{board.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.boardMasterId && <p style={{ color: 'red' }}>{error.boardMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='streamOrMediumMasterId' onChange={handleInputChange} value={literacyVideosData.streamOrMediumMasterId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            formData?.streamOrMediumData?.map((stream) => {
                                                                return <option key={stream.id} value={stream.id}>{stream.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.streamOrMediumMasterId && <p style={{ color: 'red' }}>{error.streamOrMediumMasterId}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={ClassList.filter(option =>
                                                            literacyVideosData.gradeMasterIds && literacyVideosData.gradeMasterIds.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="gradeMasterIds"
                                                        options={ClassList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeBoard}
                                                    />
                                                    {error.gradeMasterIds && <p style={{ color: 'red' }}>{error.gradeMasterIds}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select FLN Tag :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='flnTagMasterId' onChange={handleInputChange} value={literacyVideosData.flnTagMasterId}>
                                                        <option selected value={''} disabled>Select FLN Tag</option>
                                                        {
                                                            flnTag?.map((tag) => {
                                                                return <option key={tag.id} value={tag.id}>{tag.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.flnTagMasterId && <p style={{ color: 'red' }}>{error.flnTagMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Video Url:</label>
                                                    <input required type="text" className="form-control" name="filePath" value={literacyVideosData.filePath} onChange={handleInputChange} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={literacyVideosData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={literacyVideosData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={literacyVideosData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLiteracyVideos}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="reset" style={{ marginRight: '20px' }} onClick={() => { setLiteracyVideoList([]); setEditId(''); setLiteracyVideosData(initialFormState) }}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Board
                                                                            <SortIcon sortState={boardSort} setSortState={setBoardSort} setData={setLiteracyVideoList} setCurrPage={setCurrPage} sortingPath={"boardMasterDetails.boardName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setLiteracyVideoList} setCurrPage={setCurrPage} sortingPath={"streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">
                                                                            FLN Tag Name
                                                                            <SortIcon sortState={tagNameSort} setSortState={setTagNameSort} setData={setLiteracyVideoList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">Video</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((videoData, index) => {
                                                                                return (
                                                                                    <tr key={videoData.id}>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{videoData.boardMasterDetails.boardName}</td>
                                                                                        <td>{videoData.streamOrMediumMasterDetails.streamName}</td>
                                                                                        <td>{videoData.flnMasterGradeMappingDetails.map((i) => `${i.gradeMasterDetails.gradeName}`).join(", ")}</td>
                                                                                        <td>{videoData?.flnTagMasterDetails?.tagName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(videoData.filePath)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteVideo(videoData.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Literacy Videos Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={literacyVideoList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <CModal
                backdrop="static"
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                className={isFullScreen ? "full_scr_view" : ""}
            >
                <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                <div className="test test-player">
                    <ReactPlayer
                        ref={playerRef}
                        url={showPdfLink}
                        playing={play}
                        volume={volume}
                        onProgress={handleProgress}
                        playbackRate={playbackRate}
                    >
                    </ReactPlayer>
                    <div className="overlay-layer">
                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                    </div>
                </div>
                <div className="video_content_bottom">
                    <div className="video_progress">
                        <input
                            type="range"
                            min={0}
                            max={1}
                            step="any"
                            value={played}
                            onChange={handleSeekChange}
                            className="input_slider"
                        />
                    </div>

                    <div className='play_pause_sound'>
                        <div className='sound'>
                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}

                            {volume >= 0.5 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-high"></i>
                            </button>}
                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-low"></i>
                            </button>}
                            {volume == 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-xmark"></i>
                            </button>}

                            <div className='sound_bar'>
                                <input
                                    type="range"
                                    value={volume}
                                    onChange={handleVolumeChange}
                                    min="0"
                                    max="1"
                                    step="0.01"
                                    className="input_slider"
                                />
                            </div>
                        </div>
                        <div className='playbeack_speed'>
                            <span>Playback speed</span>
                            <select onClick={handleSpeedChange}>
                                <option value={0.25}>0.25</option>
                                <option value={0.5}>0.5</option>
                                <option value={0.75}>0.75</option>
                                <option selected value={1}>Normal</option>
                                <option value={1.25}>1.25</option>
                                <option value={1.5}>1.5</option>
                                <option value={1.75}>1.75</option>
                            </select>
                        </div>
                        <div className='fullscreen_mode'>
                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                        </div>
                    </div>
                </div>
            </CModal>
        </>
    );
};

export default LiteracyVideos;